// import { useState } from "react";
import { useSelector} from 'react-redux'
// import { Logout } from '../services/Reducer'
// import { useNavigate } from "react-router-dom";

function Loader(props) {
  const Display = useSelector((state) => state.ReducerData.display);
  
  return (
    <>
      <div
        className="modal fade bs-example-modal-sm show"
        tabIndex="-1"
        aria-labelledby="mySmallModalLabel"
        style={{display:Display,background:"#595555a1"}}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-sm">
          <div className="modal-content" style={{width:"143px",left:"30%",top:"91px"}}>
            <div className="modal-body" style={{textAlign:"center"}}>
              <div className="spinner-border text-dark m-1" role="status">
                {/* <span className="sr-only">Loading...</span> */}
              </div>
              
              <div className="text-loading"> Loading... </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Loader;


